import type { ReactNode } from "react";
import { useDevice } from "@/shared/hooks/useDevice";
import { DesktopLayout } from "./desktop/DesktopLayout";
import { MobileLayout } from "./mobile/MobileLayout";

interface Props {
  children: ReactNode;
}

/**
 * Device に応じて Mobile / Desktop layout を出し分けるルート Layout。
 * `useDevice` は mount 時に 1 回固定なので switch も初期化時に 1 回。
 */
export const RootLayout: React.FunctionComponent<Props> = ({
  children,
}: Props) => {
  const device = useDevice();
  return device === "desktop" ? (
    <DesktopLayout>{children}</DesktopLayout>
  ) : (
    <MobileLayout>{children}</MobileLayout>
  );
};
